import { QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Toaster } from "sonner"

import { App } from "./App"
import "./index.css"
import { AuthProvider } from "./lib/auth"
import { queryClient } from "./lib/client"
import { ThemeProvider } from "./lib/theme"

const elem = document.getElementById("root")!

function Root() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <App />
          <Toaster position="top-right" theme="dark" />
        </QueryClientProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

const app = (
  <StrictMode>
    <Root />
  </StrictMode>
)

;(import.meta.hot.data.root ??= createRoot(elem)).render(app)
